var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import DataLayer from "@lonelyplanet/dotcom-core/dist/containers/dataLayer";
import { Urls } from "@lonelyplanet/dotcom-routing/dist/create";
import { poiTypes } from "@lonelyplanet/dotcom-routing/dist/details/constants";
import { Helmet } from "@lonelyplanet/travel-agent/dist/helmet";
import { Heading } from "backpack-ui/dist/components/text";
import * as React from "react";
import { Ad, AdUnit } from "../../shared/components/ad";
import Panel from "../../shared/components/panel";
import Template from "../../shared/components/template";
import Breadcrumbs from "../../shared/patterns/breadcrumbs";
import { containingPlaceForRelatedActivities } from "../../shared/utils/slug";
import { MapInteractiveAsync as Map } from "./components/map/mapInteractiveAsync";
import SuggestEdit from "./components/suggestEdit";
import Activities from "./patterns/activities";
import Header from "./patterns/header";
import Hero from "./patterns/hero";
import Info from "./patterns/info";
import Review from "./patterns/review";
import Tour from "./patterns/tour";
import * as styles from "./styles/pois.css";
import TemplatePoiDetail from "./templates/detail";
import { createAdTargeting } from "./utils/createAdTargeting";
import { formatAddressExtras } from "./utils/formatAddressExtras";
import heroImageSizes from "./utils/heroImageSizes";
import { viatorMoreLink } from "./utils/providerLinkBuilder";
import { showDetailsSection } from "./utils/showDetailsSection";
import Divider from "../../shared/components/divider";
import { analytics, DataLayerInitializationData, DestinationSubNavs, } from "@lonelyplanet/lp-analytics";
import Tags from "./patterns/tags/index";
var PagePoi = function (_a) {
    var poi = _a.poi, related = _a.related, tour = _a.tour, tags = _a.tags, breadcrumbs = _a.breadcrumbs, isDOM = _a.isDOM, dataLayer = _a.dataLayer, nearbyMapMarkers = _a.nearbyMapMarkers, bookmarked = _a.bookmarked, onClickBookmark = _a.onClickBookmark, location = _a.location, match = _a.match;
    var _b;
    var isTopChoice = poi.poiAttributes &&
        poi.poiAttributes.length &&
        poi.poiAttributes[0].name === "top_choice";
    var hasNearbyPlaces = nearbyMapMarkers && nearbyMapMarkers.length > 0;
    var hasImages = poi.images && poi.images.length > 0;
    var hasMainImageAttributions = hasImages &&
        Array.isArray(poi.images[0].attribution) &&
        poi.images[0].attribution.length > 0;
    var subtype = poiTypes[poi.poiType.toLowerCase()].displayName;
    var metaImage = hasImages ? poi.images[0].url : "";
    var moreTourLink = related.length > 0 && viatorMoreLink(__assign({}, related[0], {
        containingPlaceId: match.params.placeId,
        containingPlaces: poi.containingPlaces,
    }));
    var adTargeting = createAdTargeting(dataLayer);
    var destinationSubNav = (function () {
        switch (poi.poiType) {
            case "eating":
                return DestinationSubNavs.restaurants;
            case "sleeping":
                return DestinationSubNavs.hotels;
            default:
                return DestinationSubNavs.experiences;
        }
    })();
    return (React.createElement(React.Fragment, null,
        React.createElement(Helmet, null,
            React.createElement("meta", { property: "og:image", content: metaImage }),
            React.createElement("meta", { className: "swiftype", name: "op-parent-id", "data-type": "string", content: poi.containingCityId }),
            React.createElement("meta", { className: "swiftype", name: "op-parent-name", "data-type": "string", content: poi.containingCityName }),
            React.createElement("meta", { className: "swiftype", name: "op-subtype", "data-type": "string", content: subtype }),
            React.createElement("meta", { className: "swiftype", name: "op-type-poi", "data-type": "integer", content: "100" }),
            React.createElement("meta", { className: "swiftype", name: "top-choice", "data-type": "integer", content: isTopChoice ? "1" : "0" }),
            React.createElement("meta", { className: "swiftype", name: "grade", "data-type": "float", content: (poi.lpInternalScore && poi.lpInternalScore.toString()) || "0" }),
            React.createElement("meta", { className: "swiftype", name: "thumbnail", "data-type": "string", content: metaImage }),
            tags.map(function (tag) { return ([
                React.createElement("meta", { className: "swiftype", name: "tag", "data-type": "string", content: tag.label }),
                React.createElement("meta", { className: "swiftype", name: tag.tag_type + "-id", "data-type": "enum", content: tag.tag_id })
            ]); })),
        React.createElement(DataLayer, { data: {
                kind: poi.poiType,
                subtypes: poi.subtypes.join(", "),
            } }),
        React.createElement(DataLayerInitializationData, { data: (_b = {},
                _b[analytics.atlasId] = poi.id,
                _b[analytics.contentCity] = poi.containingCityName,
                _b[analytics.contentCountry] = poi.containingCountryName,
                _b[analytics.contentNeighborhood] = poi.containingPlaceName,
                _b[analytics.destinationSubNav] = destinationSubNav,
                _b[analytics.poiName] = poi.name,
                _b[analytics.poiType] = poi.poiType,
                _b[analytics.poiAttributes] = poi.poiAttributes,
                _b), indexForEntirePayload: 1 }),
        React.createElement(TemplatePoiDetail, null,
            React.createElement(Template.Position, { area: "breadcrumbs" },
                React.createElement(Breadcrumbs, { className: styles.breadcrumbs, links: breadcrumbs })),
            React.createElement(Template.Position, { area: "header" },
                React.createElement(Header, { title: poi.name, type: poi.subtypes[0], location: poi.containingPlaceName || poi.containingCityName, topChoice: isTopChoice, bookmarked: bookmarked, onClickBookmark: onClickBookmark, link: location })),
            hasImages &&
                React.createElement(Template.Position, { area: "hero" },
                    poi.images.length === 1 &&
                        React.createElement(Hero.Photo, { src: poi.images[0].url, sizes: heroImageSizes.single.main }),
                    poi.images.length > 1 &&
                        React.createElement(Hero.Gallery, { images: poi.images.map(function (image) { return image.url; }) })),
            hasMainImageAttributions &&
                React.createElement(Template.Position, { area: "heroAttribution" },
                    React.createElement(Hero.Attribution, { attributions: poi.images[0].attribution })),
            poi.review && poi.review.essential &&
                React.createElement(Template.Position, { area: "reviewEssential" },
                    React.createElement(Review.Essential, null,
                        React.createElement("div", { dangerouslySetInnerHTML: { __html: poi.review.essential } }))),
            related && related.length > 0 &&
                React.createElement(Template.Position, { area: "callToActionAside" },
                    React.createElement(Panel, null,
                        React.createElement(Heading, { size: 5, level: 4, weight: "medium" }, "Tickets & tours"),
                        React.createElement(Activities, { data: related, url: moreTourLink, parentActivityName: poi.name, placeId: containingPlaceForRelatedActivities(poi.containingPlaces) || match.params.placeId, containingPlaces: poi.containingPlaces }),
                        React.createElement(Divider, { className: styles.divider }))),
            tags && tags.length > 0 &&
                React.createElement(Template.Position, { area: "poiTags" },
                    React.createElement(Tags, { data: tags })),
            showDetailsSection(poi) &&
                React.createElement(Template.Position, { area: "infoLocation" },
                    React.createElement(Info, null,
                        React.createElement(Info.Heading, null, "Details"),
                        (poi.address && poi.address.street) &&
                            React.createElement(Info.Item, null, poi.address.street),
                        (poi.address && poi.address.extras) &&
                            React.createElement(React.Fragment, null, formatAddressExtras(poi.address.extras).map(function (item) { return (React.createElement(Info.Item, { label: item.label }, item.text)); })),
                        (poi.telephone && poi.telephone.national) &&
                            React.createElement(Info.Item, null,
                                React.createElement("a", { href: "tel:" + (poi.telephone.callingCode || "") +
                                        ("" + poi.telephone.national.replace(/-|\s/g, "")) }, poi.telephone.national)),
                        (poi.emails && poi.emails.length) &&
                            React.createElement(Info.Item, null, Array.isArray(poi.emails) ? poi.emails[0] : poi.emails),
                        poi.website &&
                            React.createElement(Info.Item, null,
                                React.createElement("a", { href: poi.website }, "Visit website")),
                        poi.hours &&
                            React.createElement(Info.Item, { label: "Hours" }, poi.hours),
                        poi.price &&
                            React.createElement(Info.Item, { label: "Price" }, poi.price))),
            React.createElement(Template.Position, { area: "adRail" },
                React.createElement(Ad.Primary, null,
                    React.createElement(AdUnit.SideRail, { adUnit: "poisRightRail", targeting: adTargeting }))),
            (poi.location && poi.location.coordinates && poi.location.coordinates.length) && hasNearbyPlaces &&
                React.createElement(Template.Position, { area: "map" }, isDOM &&
                    React.createElement(Map, { center: {
                            coordinates: poi.location.coordinates.slice(0).reverse(),
                            name: poi.name,
                        }, markers: nearbyMapMarkers })),
            poi.review && poi.review.extension &&
                React.createElement(Template.Position, { area: "reviewExtension" },
                    React.createElement(Review.Extension, null,
                        React.createElement("div", { dangerouslySetInnerHTML: { __html: poi.review.extension } }))),
            tour && tour.length > 0 &&
                React.createElement(Template.Position, { area: "tour" },
                    React.createElement(Tour, { image: tour[0].images[0].url, title: tour[0].name, duration: tour[0].duration.duration + " " + tour[0].duration.unit, destinations: tour[0].departureInfo + " to " + tour[0].returnInfo, price: tour[0].pricing.regularPrice.formattedAmount, url: Urls.create(__assign({}, tour[0], { containingPlaces: poi.containingPlaces })) })),
            React.createElement(Template.Position, { area: "suggestEdit" },
                React.createElement(SuggestEdit, { poi: poi, location: location })),
            React.createElement(Template.Position, { area: "adSuperzone" },
                React.createElement(Ad.Bounded, null,
                    React.createElement(AdUnit.Superzone, { adUnit: "poisSuperzone", targeting: adTargeting }))))));
};
export default PagePoi;



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/poi.tsx
// module id = rDgH
// module chunks = 2